import gql from 'graphql-tag'

export const GET_ALL_ORGANIZATION = gql`
    query Organizations{
        Organizations{
            id
            name
            mobile
        }
    }`

export const GET_PREFERRED_DISTRIBUTOR = gql`
    query PrefferedDistributors($partnerId:uuid!){
        PrefferedDistributors(where: {partnerId: {_eq: $partnerId}}){
            id
            partnerId
            PrefferedPartner{
                id
                name
                mobile
                email
            }
        }
    }`

export const GET_RETURN_ORDER_COUNT_OF_PARTNER = gql`
    query Orders($from:uuid!){
        ReturnOrderCount:Orders_aggregate(where: {from: {_eq: $from}, orderType: {_eq: 3}}){
            aggregate {
                count
            }
        }
    }`

export const GET_ORDER_OF_DISTRIBUTOR = gql`
    query Orders($from:uuid!, $to:uuid!){
        Orders(where: {from: {_eq: $from}, to: {_eq: $to}, orderType: {_eq: 1}, status:{_in:["Sold","Paid"]}}, order_by: {createdOn: desc}){
            id
            orderNum
            createdOn
        }
    }`

export const GET_ORDERITEMS_OF_ORDER = gql`
    query OrderItems($orderId:uuid!){
        OrderItems(where: {orderId: {_eq:$orderId}}, order_by: {createdOn: desc}){
            id
            isReturned
            schemePoints
            Batch{
                id
                status
                ownedBy
                isOpened
                sku
                batch
                Product{
                    id
                    name
                }
            }
        }
    }`

export const GET_RETURN_ORDER_HISTORY = gql`
    query ReturnOrderHistory($partnerId:uuid!,$schemeId:uuid!) {
        ReturnOrderHistory:SchemePointsHistoryOrderWise(where: {partnerId: {_eq: $partnerId}, schemeId: {_eq: $schemeId}, returnOrderPoint: {_neq:0}, earnPoint: {_eq: 0}, eligiblePoint: {_eq: 0}, adjustment: {_eq: 0}, Order: {id: {_is_null: false}}}, distinct_on: orderId) {
            id
            returnOrderBoosterPoint
            returnOrderPoint
            eligiblePoint
            Order{
                id
                status
                orderNum
                date
                createdOn
                invoiceDate
                invoiceNumber
                FromOrganization{id name PartnerType{id name prefix} }
                ToOrganization{id name PartnerType{id name prefix} }
                OrderItems_aggregate{ aggregate{count} }
            }
        }
    }`

export const GET_RETURN_ORDER_DETAIL = gql`
    query Orders($orderId: uuid!){
        ReturnOrderDetail:Orders(where: {id: {_eq: $orderId}}){
            id
            status
            orderNum
            date
            invoiceDate
            invoiceNote
            invoiceNumber
            createdOn
            PlacedBy{id name}
            FromOrganization{id name PartnerType{id name prefix} }
            ToOrganization{id name PartnerType{id name prefix} }
            OrderItems{
                id
                productId
                orderItemId: id
                orderItemStatus: status
                Product{name id productLineCode ProductLine{name} OEM {name}}
                Batch{batch id productId status sku}
            }
        }
    }
`
